<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-content">
      <md-card>
        <md-card-header>
          <h4 class="text-md font-bold">{{ modo === 'ver' ? 'Detalle del Vuelo' : 'Editar Vuelo' }}</h4>
          <md-button class="md-icon-button" @click="$emit('cerrar')" style="float:right;">X</md-button>
        </md-card-header>
        <md-card-content>
          <div v-if="modo === 'ver'">
            <div v-for="(valor, campo) in vuelo" :key="campo">
              <strong>{{ etiquetas[campo] || campo }}:</strong> {{ valor }}
            </div>
            <div v-for="(servs, categoria) in servicios" :key="categoria">
              <h5 class="text-sm font-semibold mt-4">{{ categoria }}</h5>
              <md-table>
                <thead>
                  <tr>
                    <th>Servicio</th>
                    <th>Constancias</th>
                    <th>Total</th>
                    <th>Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(servicio, idx) in servs" :key="idx">
                    <td>{{ servicio.servicio }}</td>
                    <td>{{ servicio.constancias }}</td>
                    <td>{{ servicio.total }}</td>
                    <td>{{ servicio.observaciones }}</td>
                  </tr>
                </tbody>
              </md-table>
            </div>
          </div>

          <div v-else>
            <div v-for="(valor, campo) in editData" :key="campo">
              <md-field v-if="campo !== 'id'">
                <label>{{ etiquetas[campo] || campo }}</label>
                <select v-if="campo === 'regional_id'" v-model="editData.regional_id">
                  <option v-for="reg in regionales" :key="reg.id" :value="reg.id">{{ reg.nombre }}</option>
                </select>
                <md-input v-else v-model="editData[campo]" :type="campo === 'fecha' ? 'date' : 'text'" />
              </md-field>
            </div>

            <div v-for="(servs, categoria) in servicios" :key="categoria">
              <h5 class="text-sm font-semibold mt-4">{{ categoria }}</h5>
              <md-table>
                <thead>
                  <tr>
                    <th>Servicio</th>
                    <th>Constancias</th>
                    <th>Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(servicio, idx) in servs" :key="idx">
                    <td>{{ servicio.servicio }}</td>
                    <td>
                      <md-field>
                        <md-input v-model.number="servicio.constancias" type="number" min="0" />
                      </md-field>
                    </td>
                    <td>
                      <md-field>
                        <md-input v-model="servicio.observaciones" />
                      </md-field>
                    </td>
                  </tr>
                </tbody>
              </md-table>
            </div>
            <md-button class="md-raised md-primary" @click="guardar">Guardar</md-button>
            <md-button class="md-raised" @click="$emit('cerrar')">Cancelar</md-button>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    modo: String,
    vuelo: Object,
    servicios: Object,
    regionales: Array
  },
  data() {
    return {
      editData: { ...this.vuelo },
      etiquetas: {
        id: 'ID',
        numero_vuelo: 'Número de Vuelo',
        fecha: 'Fecha',
        numero_constancia: 'Número de Constancia',
        regional_id: 'Regional',
      }
    };
  },
  watch: {
    vuelo: {
      handler(val) {
        this.editData = { ...val };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    guardar() {
      const serviciosPlanos = [];
      Object.values(this.servicios).forEach(servs => {
        servs.forEach(serv => {
          serviciosPlanos.push({
            ...serv,
            constancias: Number(serv.constancias || 0),
            total: '', // el backend lo calculará
            observaciones: serv.observaciones || ''
          });
        });
      });

      this.$emit('guardar', {
        ...this.editData,
        id: this.vuelo.id,
        servicios: serviciosPlanos
      });
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
  background: #fff;
  border-radius: 8px;
  min-width: 350px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  padding: 0;
}
</style>
